<template>
	<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="所属门店：">
				<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="search()">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="销售单号：">
				<el-input clearable v-model="formInline.orderCode" size="small" placeholder="请输入销售单号" @keyup.enter.native="inputChange"></el-input>
			</el-form-item>
			<el-form-item label="商品类型：">
				<el-select v-model="formInline.typeName" placeholder="请选择类型" clearable filterable size="small" style="width: 160px" @change="handleTypeNameChange">
					<el-option v-for="item in typeNameList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品系列：">
				<el-select v-model="formInline.productName" placeholder="请选择系列" clearable filterable size="small" style="width: 160px" @change="handleProductNameChange">
					<el-option v-for="item in productNameList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品名称：">
				<el-input v-model="formInline.specification" size="small" placeholder="请输入商品名称" clearable @keyup.enter.native="inputChange"></el-input>
			</el-form-item>
			<el-form-item label="销售日期：">
				<el-date-picker
					v-model="dateValue"
					clearable
					size="small"
					type="daterange"
					value-format="yyyy-MM-dd"
					format="yyyy-MM-dd"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					@change="handleDateChange"
				></el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</el-form-item>
		</el-form>
		<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData">
			<!--
      <el-table-column v-if="isShowMoney" slot="price" label="单价" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price }}
        </template>
</el-table-column>
<el-table-column v-if="isShowMoney" slot="money" label="金额" width="100" align="center">
  <template slot-scope="scope">
          {{ scope.row.money }}
        </template>
</el-table-column> -->
		</STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
	</topTab>
</template>

<script>
import { GetSalesOrderDtlList, GetProductTypeNameList, GetProductTypeSubNameList } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "订单明细"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			storeList: [],
			typeNameList: [],
			productNameList: [],
			dateValue: [],
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				startTime: null,
				endTime: null,
				orderCode: "",
				storeKeyId: "",
				typeName: "",
				productName: "",
				specification: ""
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "createTime",
					label: "经办时间",
					align: "center",
					width: "160",
				},
				{
					prop: "storeName",
					label: "所属门店",
					align: "center",
					isKeep: true,
					width: "120"
				},
				{
					prop: "customerInfo.name",
					label: "客户名称",
					align: "center",
					width: "90",
				},
				{
					prop: "code",
					label: "商品编号",
					align: "center",
					width: "220"
				},
				{
					prop: "typeName",
					label: "类型",
					align: "center",
					isKeep: true,
					width: "100"
				},
				{
					prop: "productName",
					label: "系列",
					align: "center",
					width: "150"
				},
				{
					prop: "specification",
					label: "商品名称",
					align: "center",
					minWidth: "180"
				},
				{
					prop: "price",
					label: "单价(元)",
					align: "center",
					isKeep: true,
					minWidth: "140",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "quantity",
					label: "销售数量",
					align: "center",
					width: "80"
				},
				{
					prop: "money",
					label: "金额(元)",
					align: "center",
					minWidth: "140",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "salesOrderInfo.code",
					label: "销售单号",
					align: "center",
					width: "180"
				},
				{
					prop: "salesOrderInfo.isConfirm",
					label: "是否确认",
					align: "center",
					width: "90",
					formatter: (row) => {
						return row.salesOrderInfo.isConfirm === true ? "是" : "否";
					}
				},
				{
					prop: "salesOrderInfo.confirmUserName",
					label: "确认人",
					align: "center",
					width: "90"
				},
				{
					prop: "salesOrderInfo.confirmDate",
					label: "确认时间",
					align: "center",
					width: "160"
				},
				{
					prop: "customerInfo.phone",
					label: "客户电话",
					align: "center",
					width: "120"
				},
				{
					prop: "customerInfo.customerNo",
					label: "客户编号",
					align: "center",
					width: "100"
				},
				{
					prop: "creator",
					label: "经办人",
					align: "center",
					width: "80"
				}
			]
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetOrganizationListByConfig();
		this.getProductTypeNameList();
		this.getProductTypeSubNameList(this.formInline.typeName);
		this.search();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		},
		// 类型改变：清空系列、重载系列列表并查询
		handleTypeNameChange(val) {
			this.formInline.productName = "";
			this.getProductTypeSubNameList(val);
			this.search();
		},
		// 系列改变：查询
		handleProductNameChange(val) {
			this.formInline.productName = val;
			this.search();
		},
		// 获取商品类型列表
		getProductTypeNameList() {
			GetProductTypeNameList({}).then((res) => {
				if (res.code == 1) {
					this.typeNameList = (res.data || []).map((item) => ({
						keyId: item.value,
						value: item.value
					}));
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 根据类型获取系列列表
		getProductTypeSubNameList(code) {
			GetProductTypeSubNameList({ code: code }).then((res) => {
				if (res.code == 1) {
					this.productNameList = (res.data || []).map((item) => ({
						keyId: item.value,
						value: item.value
					}));
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetSalesOrderDtlList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
						this.totalQuantity = res.totalQuantity;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 获取所属门店
		GetOrganizationListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
						this.storeList.unshift({
							keyId: "",
							value: "所有门店"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		}
	}
};
</script>

<style scoped>
.one_1 {
	padding: 2px 20px;
	background: #e6f7ff;
	border: 1px solid #6acaf3;
	color: #56bbfd;
	border-radius: 2px;
}

.one_2 {
	padding: 2px 20px;
	background: #fcd4ff;
	border: 1px solid #dfbce2;
	color: #ea7cff;
	border-radius: 2px;
}
</style>
